import axios from 'axios';
import { toast } from 'react-toastify';
import {
  DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_BEGIN,
  DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_SUCCESS,
  DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_FAILURE,
  DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
export function listDeploymentSetting(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_BEGIN,
    });
    const { projectId, page, limit } = args;
    const header = builderSurfaceJsonContentHeader(projectId, true);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}deployment/setting`;
      if (page || page === 0) {
        url += `?limit=${limit}&page=${page}`;
      }

      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_SUCCESS,
            data: res.data,
            pageNumber: page,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissListDeploymentSettingError() {
  return {
    type: DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_BEGIN:
      return {
        ...state,
        listDeploymentSettingPending: true,
        listDeploymentSettingError: null,
      };

    case DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_SUCCESS:
      return {
        ...state,
        listDeploymentSettingPending: false,
        listDeploymentSettingError: null,
        settings: action.data.result ? action.data.result : action.data,
        totalSettings: action.data.totalPages ? action.data.totalPages : state.totalSettings,
        currentSettingPage:
          action.pageNumber || action.pageNumber === 0
            ? action.pageNumber
            : state.currentSettingPage,
      };

    case DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_FAILURE:
      return {
        ...state,
        listDeploymentSettingPending: false,
        listDeploymentSettingError: action.data.error,
      };

    case DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_DISMISS_ERROR:
      return {
        ...state,
        listDeploymentSettingError: null,
      };

    default:
      return state;
  }
}
